var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insurance-error-label"},[_c('div',{staticClass:"required-message"},[_vm._v(" This information is required to continue. ")]),_c('div',{staticClass:"invalid-message"},[_vm._v(" "+_vm._s(_vm.invalidString)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }